export default __webpack_public_path__ + "static/media/chrome.096cd3be.svg";